var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "99.999319%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#246FDB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2973DF",
    offset: "5.52%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#377DEB",
    offset: "27.81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F83F2",
    offset: "54.91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285F4",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.2,82.8 C198.2,107.8 198.2,148.3 173.2,173.3 C160.7,185.8 160.7,206.1 173.2,218.5 C185.7,231 206,231 218.5,218.5 C268.5,168.5 268.5,87.5 218.5,37.5 L173.2,82.8 Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.4,37.5 C168.4,-12.5 87.5,-12.5 37.5,37.5 C-12.5,87.5 -12.5,168.5 37.5,218.5 L82.8,173.3 C57.8,148.3 57.8,107.8 82.8,82.8 C107.8,57.8 148.3,57.8 173.3,82.8 C185.8,95.3 206.1,95.3 218.6,82.8 C230.9,70.3 230.9,50 218.4,37.5 Z",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.4,218.5 L173.1,173.3 C148.1,198.3 107.6,198.3 82.6,173.3 L37.3,218.5 C87.5,268.5 168.4,268.5 218.4,218.5 Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.2,173.3 C185.7,160.8 205.9,160.8 218.4,173.3 C230.9,185.8 230.9,206.1 218.4,218.6 C205.9,231.1 185.7,231.1 173.2,218.6 C160.7,206.1 160.7,185.8 173.2,173.3 Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5,173.3 C50,160.8 70.2,160.8 82.7,173.3 C95.2,185.8 95.2,206.1 82.7,218.6 C70.2,231.1 50,231.1 37.5,218.6 C25,206.1 25,185.8 37.5,173.3 Z",
    fill: "#34A853"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmp);
export default __webpack_public_path__ + "static/media/gmp.9b712abff7a6ba9cf002dc28b6c0f7cd.svg";
export { ForwardRef as ReactComponent };